import { render, staticRenderFns } from "./inquiry.vue?vue&type=template&id=750bdf55&scoped=true&"
import script from "./inquiry.vue?vue&type=script&lang=ts&"
export * from "./inquiry.vue?vue&type=script&lang=ts&"
import style0 from "./inquiry.vue?vue&type=style&index=0&id=750bdf55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750bdf55",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
